import { fractionToAmountCents } from '@utils/allocationUnits';
import { allocationCellKey } from './allocationCellKey';

// Locks and solver output are whole cents, so the cap is compared in cents:
// a value that rounds to the cap's cents sits at the cap, not over it.
export const exceedsCapacityCents = (
  requestedCents: number,
  capacityFraction: number,
  mvCents: number,
) => requestedCents > fractionToAmountCents(capacityFraction, mvCents);

export const capacityViolationKeys = ({
  cells,
  members,
  capacityFractionByKey,
}: {
  cells: { sa: string; fp: string; fraction: number }[];
  members: { sa: string; mvCents: number }[];
  capacityFractionByKey?: ReadonlyMap<string, number>;
}) => {
  const violationKeys = new Set<string>();
  if (!capacityFractionByKey) return violationKeys;

  const mvCentsBySa = new Map(members.map((m) => [m.sa, m.mvCents]));
  for (const cell of cells) {
    const key = allocationCellKey(cell.sa, cell.fp);
    const capacity = capacityFractionByKey.get(key);
    if (capacity === undefined) continue;

    const mvCents = mvCentsBySa.get(cell.sa) ?? 0;
    if (
      exceedsCapacityCents(
        fractionToAmountCents(cell.fraction, mvCents),
        capacity,
        mvCents,
      )
    ) {
      violationKeys.add(key);
    }
  }
  return violationKeys;
};
